<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    v-model="dialog"
    persistent
  >
    <v-card>
      <v-toolbar :color="colorDialog" dark>{{ tituloDialogForm }}</v-toolbar>
      <v-card-text>
        <template v-if="bandera == 0">
          <div class="text-h6 pa-12">
            {{ mensajeDelDialog }}
          </div>
        </template>
        <template v-if="bandera == 1">
          <div class="text-h6 pa-12">
            {{ mensajeDelDialog }}
          </div>
        </template>
        <template v-if="bandera == 2">
          <div class="text-h6 pa-12">
            {{ mensajeDelDialog }}
          </div>
        </template>
        <template v-if="bandera == 3">
          <div class="text-h6 pa-12">
            {{ mensajeDelDialog }}
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="justify-end">
        <template v-if="bandera == 1">
          <v-btn color="primary" @click="cerrarModal">Cerrar</v-btn>
        </template>
        <template v-if="bandera == 2">
          <v-btn color="primary" @click="devolverValor(true)">SI</v-btn>
          <v-btn color="primary" @click="devolverValor(false)">NO</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    bandera: 0,
    colorDialog: "",
    dialog: "",
    mensajeDelDialog: "",
    tituloDialogForm: "",
  }),

  methods: {
    async abrirMensajeDialog(mensaje, dato, color, titulo) {
      this.mensajeDelDialog = mensaje;
      this.bandera = dato;
      this.colorDialog = color;
      this.tituloDialogForm = titulo;
      this.dialog = true;
    },

    devolverValor(valor) {
      console.log("Ingreso en deovler valor");
      console.log("la opcion seleccionada es: ");
      console.log(valor);
      this.dialog = false;
      this.$emit("resultado", valor);
    },

    cerrarModal() {
      console.log("Presiono cerrar");
      this.dialog = false;
      console.log("El valor del dialog es:");
      console.log(this.dialog);
    },
  },
};
</script>

<style></style>
